module.exports = __webpack_public_path__ + "646b3cf4010eb2c928b4aa9ddff86719.svg";